import { Iconfont } from '@umu/umu-design';
import { PLACEMENT_ENUM } from '@umu/umu-design/es/components/Dropdown/interface';
import type { IMenuItemInfo } from '@umu/umu-design/es/components/Menu/interface';
import { lang } from '@umu/ukit-lang';
import React, { useMemo, useState } from 'react';
import { MenuDrop } from '../menuDrawer/dropMenu';

export interface IPaginationPageSizeSelectProps {
    selected: number;
    options: number[];
    onSelect: (size: number) => void;
}

/** 分页条「每页条数」：基于 MenuDrop（Dropdown + Menu list）展开 */
export function PaginationPageSizeSelect({ selected, options, onSelect }: IPaginationPageSizeSelectProps) {
    const [open, setOpen] = useState(false);
    const label = lang('{$0}条/页', selected);

    const list: IMenuItemInfo[] = useMemo(
        () =>
            options.map((n) => ({
                key: String(n),
                title: lang('{$0}条/页', n),
                className: n === selected ? 'is-active' : undefined,
            })),
        [options, selected],
    );

    return (
        <div className={`umu-pagination-v2-page-size-select ${open ? 'is-open' : ''}`}>
            <MenuDrop
                className="umu-pagination-v2-page-size-menudrop"
                list={list}
                trigger="click"
                placement={PLACEMENT_ENUM.BOTTOM_LEFT}
                overlayClassName="umu-pagination-v2-page-size-overlay"
                onVisibleChange={setOpen}
                onChange={(key) => {
                    const n = Number(key);
                    if (!Number.isNaN(n)) {
                        onSelect(n);
                    }
                }}
            >
                <button type="button" className="umu-pagination-v2-page-size-trigger">
                    <span className="umu-pagination-v2-page-size-label">{label}</span>
                    <Iconfont
                        type="DropDown"
                        className={`umu-pagination-v2-page-size-caret${open ? ' is-flipped' : ''}`}
                    />
                </button>
            </MenuDrop>
        </div>
    );
}
